<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      line-form
      show-save-button
      unit="收入名称"
      edit-title
      id-key="IncomeId"
      :data="data"
      form-label-width="120px"
      @create-opened="onCreateOpened"
      @opened="$refs.typeSelect.init()"
      @closed="$refs.typeSelect.clear()"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="项目类别" prop="ClassId">
          <type-select ref="typeSelect" v-model="data.ClassId" />
        </el-form-item>
        <el-form-item label="项目编码" prop="ItemCode">
          <span v-if="Mode == 0" class="detail-span">{{ data.ItemCode }}</span>
          <el-input v-else v-model="data.ItemCode" placeholder="请输入收入项目编码"></el-input>
        </el-form-item>
        <el-form-item label="收入项目" prop="ItemName">
          <el-input v-model="data.ItemName" placeholder="请输入收入名称" />
        </el-form-item>
        <el-form-item label="关联单据类型" prop="SourceType">
          <select-input placeholder="选择关联单据类型" :label="data.SourceType" v-model="data.SourceTypeId" @click="openBilltype" />
        </el-form-item>
        <el-form-item label="序号" prop="SerialNumber">
          <el-input v-model="data.SerialNumber" v-int style="width: 100px" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <billtype-dialog :is-show="false" ref="billtypeDialog" in-dialog selectable @select="setBilltype" />
    </common-dialog>
  </div>
</template>
<script>
import billtypeDialog from '@/components/basedata/finance/incomeitems/listDialog'
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import typeSelect from './type/select'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
    billtypeDialog
  },
  data() {
    return {
      data: {
        ItemType: 0,
        ItemCode: '',
        ItemName: '',
        ClassId: 0,
        ItemId: 0,
        SourceType: '',
        SourceTypeId: '',
        Status: 1, //
        SerialNumber: 0
      },
      api: require('@/api/ba/item').default,
      code_api: require('@/api/sy/serialCode').default,
      Mode: 0,
      rules: {
        IncomeNo: [{ required: true, message: '收入编码不能为空' }],
        IncomeName: [{ required: true, message: '收入名称不能为空' }],
        ClassId: [{ required: true, message: '请选择收入类别' }],
        SourceType: [{ required: true, message: '请选择关联单据类型' }]
      }
    }
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn(this.data.ItemType, this.data.ClassId || 0).then(res => {
        this.data.SerialNumber = res
      })

      this.code_api.previewNo('收入项目').then(res => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.ItemCode = res.Data.PreviewNo
        } else {
          this.$message.warning('获取收入项目编号失败')
        }
      })
    },
    setBilltype(data) {
      console.log('data', data)
      this.data.SourceTypeId = data.SourceTypeId
      this.data.SourceType = data.SourceType
    },
    openBilltype() {
      this.$refs.billtypeDialog.open().then(that => {
        that.getData({ Status: 1 })
      })
    }
  }
}
</script>